export const SI_NO = ["SI", "NO"];
export const ATTIVITA_OPTIONS = ["Trasporto sanitario", "Trasporto sanitario medio/lungo raggio", "Assistenza a evento o manifestazione", "Scorta sanitaria", "Altro"];
export const MEZZO_OPTIONS = ["Ambulanza", "Doblò", "Auto Medica", "Pulmino Attrezzato", "Altro"];
export const MOBILIZZAZIONE_OPTIONS = ["Autonomo", "Carrozzina", "Barella"];
export const CAUSALE_OPTIONS = ["Visita", "Dimissione", "Ricovero", "Dialisi", "Trasferimento", "Esami diagnostici", "Altro"];
export const TRATTA_OPTIONS = ["Andata", "Andata e Ritorno"];
export const INCASSO_OPTIONS = [
  "Incasso diretto Ente - Fee da detrarre",
  "Fatturare a Nexus Italia Group - Fee già detratta",
  "Incasso diretto Ente - Ente esterno non partner N.I.G.",
  "Incasso diretto Ente - Fee NON APPLICATA",
  "Nexus Italia Group - Servizi Sanitari",
  "Fatturare a N.I.G. - Convenzione Sacra Famiglia",
  "Fatturare a N.I.G. - Convenzione San Michele",
  "Fatturare a N.I.G. - Convenzione Visconti",
];
export const PAGAMENTO_OPTIONS = ["Carta di Credito/Debito (POS)", "Contanti", "Bonifico Bancario", "Link carta di credito/debito", "Gratuito", "Convenzione"];
